// extracted by mini-css-extract-plugin
module.exports = {"item":"RequirementItem_item__1wGsk","index":"RequirementItem_index__345ES"};